export const heroStats = [
  { label: '当前版本', value: 'v6.2.8' },
  { label: '安装包大小', value: '42.6 MB' },
  { label: '最近更新', value: '2026-10-08' },
  { label: '支持平台', value: '安卓 / 苹果 / 电脑端' },
];

export const downloadPlatforms = [
  {
    key: 'android',
    name: '安卓手机版',
    icon: 'ri-android-line',
    tag: '推荐',
    version: 'v6.2.8',
    size: '42.6 MB',
    requirement: 'Android 7.0 及以上',
    language: '简体中文',
    updateTime: '2026-10-08',
    desc: '官方手机版安装包，适配主流安卓机型。下载完成后按系统提示授予安装权限即可完成安装。',
    filename: 'ppsp-android-v6.2.8.apk',
  },
  {
    key: 'ios',
    name: '苹果手机版',
    icon: 'ri-apple-line',
    tag: '稳定',
    version: 'v6.2.6',
    size: '56.3 MB',
    requirement: 'iOS 13.0 及以上',
    language: '简体中文',
    updateTime: '2026-10-05',
    desc: '苹果手机版安装文件，安装后需要在“设置 - 通用 - VPN与设备管理”中信任描述文件才能正常打开。',
    filename: 'ppsp-ios-v6.2.6.mobileconfig',
  },
  {
    key: 'desktop',
    name: '电脑网页版',
    icon: 'ri-computer-line',
    tag: '免安装',
    version: 'v6.2.8',
    size: '免下载',
    requirement: 'Chrome / Edge 90+',
    language: '简体中文',
    updateTime: '2026-10-08',
    desc: '无需安装客户端，通过浏览器直接在线访问即可使用。适合临时使用或存储空间有限的设备。',
    filename: 'ppsp-web-online',
  },
];

export const addressLines = [
  {
    name: '主线路 · 官网入口',
    host: 'ppsp-video-home.com',
    region: '全球通用',
    speed: '极速',
    status: 'available',
    note: '日常访问优先使用，线路稳定',
  },
  {
    name: '备用线路 A',
    host: 'ppsp-video-backup-a.com',
    region: '亚洲节点',
    speed: '快速',
    status: 'available',
    note: '主线路异常时切换使用',
  },
  {
    name: '备用线路 B',
    host: 'ppsp-video-backup-b.com',
    region: '欧美节点',
    speed: '稳定',
    status: 'available',
    note: '海外网络环境推荐',
  },
  {
    name: '移动专线',
    host: 'ppsp-video-mobile.com',
    region: '移动网络优化',
    speed: '快速',
    status: 'available',
    note: '手机流量访问更顺畅',
  },
  {
    name: '加速镜像',
    host: 'ppsp-video-mirror.com',
    region: 'CDN 加速',
    speed: '极速',
    status: 'maintenance',
    note: '当前维护中，请先使用其他线路',
  },
];

export const features = [
  {
    icon: 'ri-hd-line',
    title: '高清播放',
    desc: '支持从标清到高清多档画质切换，画面清晰流畅，弱网环境下也能自动匹配合适清晰度。',
    tag: '画质',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存',
    desc: '喜欢的片段可以缓存到本地，通勤、出差途中没有网络也能继续观看，缓存进度随时可见。',
    tag: '离线',
  },
  {
    icon: 'ri-history-line',
    title: '观看记录同步',
    desc: '登录后观看进度自动记录，换设备后从上次中断的位置继续，不用再手动寻找。',
    tag: '同步',
  },
  {
    icon: 'ri-flashlight-line',
    title: '秒开加载',
    desc: '优化过的加载策略让列表与播放页响应更快，点击即开，减少等待时间。',
    tag: '速度',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '隐私保护',
    desc: '支持应用锁与无痕浏览，本机记录可一键清理，减少个人使用痕迹被他人看到的可能。',
    tag: '安全',
  },
  {
    icon: 'ri-magic-line',
    title: '智能推荐',
    desc: '根据观看偏好整理首页内容，减少无关信息干扰，让每次打开都能更快找到想看的。',
    tag: '推荐',
  },
];

export const installSteps = [
  {
    step: '01',
    icon: 'ri-download-line',
    title: '获取安装包',
    desc: '在本页「下载方式」区域选择对应的平台，点击下载按钮获取最新版安装包文件。',
  },
  {
    step: '02',
    icon: 'ri-settings-3-line',
    title: '允许安装来源',
    desc: '安卓设备需要在系统设置中允许来自浏览器的应用安装；苹果设备需在设备管理中信任描述文件。',
  },
  {
    step: '03',
    icon: 'ri-smartphone-line',
    title: '完成安装',
    desc: '找到已下载的文件并点击安装，等待进度完成后图标会自动出现在桌面，安装过程通常不超过一分钟。',
  },
  {
    step: '04',
    icon: 'ri-play-circle-line',
    title: '打开使用',
    desc: '首次打开建议允许必要权限，随后即可进入资源库浏览内容，如遇问题可参考下方常见问题。',
  },
];

export const deviceRows = [
  {
    platform: '安卓手机 / 平板',
    min: 'Android 7.0',
    recommend: 'Android 11 及以上',
    storage: '约 120 MB 可用空间',
  },
  {
    platform: '苹果手机 / 平板',
    min: 'iOS 13.0',
    recommend: 'iOS 16 及以上',
    storage: '约 150 MB 可用空间',
  },
  {
    platform: '电脑网页版',
    min: 'Chrome / Edge 90',
    recommend: '最新版浏览器',
    storage: '无需额外空间',
  },
  {
    platform: '网络环境',
    min: '4 Mbps 带宽',
    recommend: '20 Mbps 及以上',
    storage: '建议 Wi-Fi 环境下使用',
  },
];

export const changelog = [
  {
    version: 'v6.2.8',
    date: '2026-10-08',
    badge: '最新',
    items: [
      '优化播放器起播速度，缩短首帧等待时间',
      '修复部分安卓机型缓存失败的问题',
      '新增多档清晰度手动切换入口',
    ],
  },
  {
    version: 'v6.2.6',
    date: '2026-10-05',
    badge: '',
    items: [
      '修复苹果设备信任描述文件后的闪退问题',
      '改进首页内容加载逻辑，翻页更顺滑',
    ],
  },
  {
    version: 'v6.2.1',
    date: '2026-09-26',
    badge: '',
    items: [
      '新增应用锁功能，可设置独立密码',
      '观看记录支持手动清理与暂停同步',
      '修复若干已知的界面显示问题',
    ],
  },
  {
    version: 'v6.1.4',
    date: '2026-09-12',
    badge: '',
    items: [
      '整体界面改版，操作路径更简短',
      '优化弱网环境下的自动降清晰度策略',
    ],
  },
];

export const faqs = [
  {
    q: '啪啪视频的最新地址在哪里查看？',
    a: '本页「最新地址」区域会持续整理当前可用的官网入口与备用线路。建议收藏本页面，当某个地址无法打开时，直接回到这里切换到标注为“可用”的其他线路即可。',
  },
  {
    q: '手机版安装包下载后无法安装怎么办？',
    a: '这种情况通常是系统拦截了未知来源的应用。请在系统设置中找到“安全”或“隐私”选项，开启允许来自浏览器的应用安装。苹果设备则需要在“设置 - 通用 - VPN与设备管理”中信任对应的描述文件。',
  },
  {
    q: '下载的安装包提示解析失败是什么原因？',
    a: '多数情况下是下载过程中断导致文件不完整。建议删除已下载的文件，换用稳定的网络环境重新下载，并确认设备的可用存储空间是否充足。',
  },
  {
    q: '电脑上可以直接使用吗？',
    a: '可以。电脑端无需下载客户端，使用较新版本的 Chrome 或 Edge 浏览器，通过官网入口在线访问即可，适合临时使用或存储空间有限的设备。',
  },
  {
    q: '观看记录能否在多个设备之间同步？',
    a: '在登录同一账号的情况下，观看记录会进行同步，换设备后可从上次中断的位置继续。如需保护隐私，也可以在设置中关闭记录同步或随时手动清理。',
  },
  {
    q: '遇到播放卡顿应该怎么处理？',
    a: '可以先尝试切换到备用线路，或降低播放清晰度；如果是移动网络访问，建议切换到 Wi-Fi 环境。部分线路在高峰期访问人数较多时速度会有所波动。',
  },
];

export const safetyTips = [
  {
    icon: 'ri-link-m',
    title: '认准本页地址',
    desc: '仅通过本页整理的最新地址访问，避免点击来路不明的短链接或第三方页面，降低被引流到仿冒站点的风险。',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '安装包来源',
    desc: '优先使用本页提供的官方安装包，不要运行他人私发或来源不明的安装文件，以免设备被植入异常程序。',
  },
  {
    icon: 'ri-lock-password-line',
    title: '保护个人信息',
    desc: '任何情况下都不要向他人泄露账号密码或验证码。本站不会以任何理由索取你的支付信息。',
  },
  {
    icon: 'ri-refresh-line',
    title: '及时更新版本',
    desc: '保持版本为最新可减少已知问题的发生。更新前建议确认设备电量与存储空间充足。',
  },
];

export const footerLinks = [
  { label: '下载方式', href: '#download' },
  { label: '最新地址', href: '#address' },
  { label: '功能特色', href: '#features' },
  { label: '安装步骤', href: '#install' },
  { label: '兼容设备', href: '#devices' },
  { label: '更新记录', href: '#changelog' },
  { label: '常见问题', href: '#faq' },
  { label: '安全提示', href: '#safety' },
];